// Icônes EDI — DÉLÈGUE au registre PARTAGÉ (`ui-tokens/icons` via `ui-web/Icon`) : un nom = un seul
// dessin sur toute la plateforme (bascule 2026-08-05 ; les noms propres EDI — inbound, outbound, clock,
// play, copy, dot — ont été absorbés au registre ; les dessins collisionnés suivent l'arbitrage
// utilisateur : canon maquette partout sauf `building`, retenu de l'EDI). Le wrapper conserve l'API
// locale (`sw`, taille 17) pour ne pas toucher les ~40 sites d'appel.
import type { CSSProperties } from 'react';
import { Icon as SharedIcon, type IconName } from '@orgazone/ui-web';
import { teal } from '@orgazone/ui-tokens';

export type { IconName };

export function Icon({ name, size = 17, sw = 1.8, style }: { name: IconName; size?: number; sw?: number; style?: CSSProperties }) {
  return <SharedIcon name={name} size={size} stroke={sw} style={{ flexShrink: 0, ...style }} />;
}

/** Logo Orgazone — ouverture teal (deux courbes) : marque de l'app, reste local. */
// ⚠️ La couleur vient du paquet de jetons en VALEUR JS, pas en `var(--teal-500)` : elle part dans un
// attribut de présentation SVG (`stroke=`), où une variable CSS ne résout pas. Même source, forme
// adaptée au support.
export function Logo({ size = 24, color = teal[500] }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
      <path d="M12 3a9 9 0 1 0 8.5 6" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
      <path d="M12 8a4 4 0 1 0 3.6 2.3" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
